import { createSlice } from "@reduxjs/toolkit";

const commonSlice = createSlice({
  name: "filters",
  initialState: {
    roomStatus: "",
  },
  reducers: {
    setRoomStatus: (state, action) => {
      state.roomStatus = action.payload;
    },
  },
});

export const { setRoomStatus } = commonSlice.actions;
export default commonSlice.reducer;
